export const ORGANISATION_URL = "رابط الموقع";
export const ORGANISATION_CODE = "الكود";
